
  import { Person } from '@/entities/persons/Person'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class PaymentOrderBeneficiariesCell extends Cell {
  declare item: any // PaymentOrder type
  persons: Person[] = []

  async mounted () {
    if (this.item?.paymentItems?.length) {
      const personIds = this.item.paymentItems
        .map(payment => payment.paymentRecipient?.person?.id || null)
        .filter(Boolean)
      this.persons = await this.fetchData({
        query: { name: 'find', model: 'Person' },
        filter: { id: { _in: personIds } },
        force: true,
      })
    }
  }

  get displayedPersons () {
    return this.persons.slice(0, 2)
  }

  get hasMorePersons () {
    return this.persons.length > 2
  }

  get remainingCount () {
    return this.persons.length - 2
  }
  }
